<div>
    <label><strong>{{itemMetadata.label}}</strong></label>
    <ng-select *ngIf="!isDropDown"
               name={{itemMetadata.displayProperty}}
               [(ngModel)]="itemMetadata.selected"
               (change)="onTypeAheadSelect()"
               [items]="items$ | async"
               [typeahead]="itemInput$"
               [disabled]="items?.length <= 0"
               [bindLabel]="itemMetadata.displayProperty"
               [clearable]="false"
               typeToSearchText="Please enter one or more characters"
               placeholder="Type to search..."
               style="width:180px;">
    </ng-select>
    <ng-select *ngIf="isDropDown"
               name={{itemMetadata.displayProperty}}
               [(ngModel)]="itemMetadata.selected"
               (change)="onTypeAheadSelect()"
               [searchable]="false"
               [clearable]="false"
               [items]="items"
               [disabled]="items?.length <= 0"
               [bindLabel]="itemMetadata.displayProperty"
               dropdownPosition="bottom"
               style="width:180px;">
    </ng-select>
</div>